export default {"src":"/_next/static/media/outlookCalendarIcon.a236f3ab.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};